import { Slider } from "@material-tailwind/react";

const ReactSlider =  ({value, onChange, name}) => {
 return  (
   <Slider value={value} onChange={onChange} inputProps={{name, id: name, minLength: 2, min: 2}} step={'1'} color="blue" min={'0'}  max={'10'} />
 )
}

export default ReactSlider;